
.with-close-option {
  position: relative;

  input {
    padding-left: 2.6em !important;
  }

  .close-btn {
    position: absolute;

    top: 35%;
    right: 1.5em;

    width: 1em;
    height: 1em;

    cursor: pointer;

    white-space: nowrap;

    // set in app/assets/stylesheets/partners/controllers/_applets.scss
    // background-image: url(/assets/icons/close.svg);
    background-position: 50%;
    background-repeat: no-repeat;
    background-origin: content-box;
    background-size: 1em;

    &:active {
      opacity: 0.8;
    }
  }

  .dropdown-service-tile {
    display: flex;
    justify-content: center;
    align-items: center;

    position: absolute;

    top: 8%;
    left: 0.5em;

    width: 2em;
    height: 2em;

    margin: 0.5em;
    padding: 0.4em;

    border-radius: 0.2em;

    img {
      width: 1.3em;
      height: auto;

      box-sizing: content-box;
      color: transparent; // hide alt text
    }
  }
}
